import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import React, { memo, useEffect } from 'react';

import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';
import { AppThemeOptions } from 'styles/theme.ts';
import { useSelector } from 'react-redux';

export const themeLtr = createTheme(AppThemeOptions);
const cacheLtr = createCache({
  key: 'muiltr',
  stylisPlugins: [prefixer],
  prepend: true,
});

export const themeRtl = createTheme({ ...AppThemeOptions, direction: 'rtl' });
const cacheRtl = createCache({
  key: 'muirtl',
  stylisPlugins: [prefixer, rtlPlugin],
  prepend: true,
});

interface Props {
  children: React.ReactNode;
}

export const AppThemeProvider = memo<Props>(({ children }) => {
  const { direction } = useSelector((state) => (state as any).language);
  const isRTL = direction === 2;

  useEffect(() => {
    document.getElementsByTagName('html')[0].setAttribute('dir', isRTL ? 'rtl' : 'ltr');
  }, [isRTL]);
  const theme = isRTL ? themeRtl : themeLtr;
  const cache = isRTL ? cacheRtl : cacheLtr;

  return (
    <CacheProvider value={cache}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </CacheProvider>
  );
});
